import { BrandliveEvent, LanguagesAbbr, PageModule, PageModuleType, Session, SessionTypesFeatures } from "../../../../../types/working-model";
import classNames from 'classnames';
import React, { CSSProperties } from "react";
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { niceDateTime } from "../../../../../utils/utils";
import Icon, { ICONS } from "../../../../general-ui/icon";
import { Link, useParams } from "react-router-dom";
import { TypographyItem } from "../../../../general-ui/typography-item/typography-item";
import { ParamsProps } from "../../../live-event";
import { eventPath } from "../../../utils";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";
import { MarketingNavMenu } from "../../../marketing-page/navigation/marketing-nav";
import { useTranslation } from "react-i18next";
import './session-header.scss';

interface SessionHeaderProps {
	session: Session;
	eventBundle: BrandliveEvent;
	isEditor?: boolean;
	editorSize?: string;
	styleOverrides?: CSSProperties;
	previewLanguage?: LanguagesAbbr;
}

const getHeaderImage = (eventBundle?: BrandliveEvent, banner?: any) => {
	//if they have explicityly set a header image, use that
	if (banner?.content?.image) {
		return banner.content.image;
	}

	//if we have the channel's logos, go through them until we find one, otherwise use the reg settings image
	if (eventBundle?.channel_logos) {
		const { color, white, gray } = eventBundle.channel_logos;
		return color || white || gray || eventBundle?.registration_settings?.image;
	}

	//last of all, return the same homepage header image
	return eventBundle?.registration_settings?.image;
};

const SessionHeader: React.FC<SessionHeaderProps> = ({
	session,
	eventBundle,
	isEditor,
	editorSize,
	styleOverrides,
	previewLanguage
}) => {
	const { uuid, language, eventName }: ParamsProps = useParams();

	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const previewMode = useTypedSelector(state => state.CreateEventReducer.previewMode);

	const { t } = useTranslation("session");
	const template = TemplateClassNames[eventBundle.template.name];
	const startDate = SessionTypesFeatures[session.session_type].has_start_time ? niceDateTime(session!.timestamp!) : null;
	const banner = eventBundle?.homepage?.modules.find((module: PageModule) => module.type === PageModuleType.main_event_banner);

	const homepageLinkImage = getHeaderImage(eventBundle, banner);
	const homepageLinkTo = `/${eventPath(eventName, uuid)}/${language}`;
	const isDesktop = editorSize === 'desktop';

	const hasLandingPage = !!workingEvent?.homepage || !!eventBundle?.homepage;

	return (
		<div className={classNames("session-header", template)} style={styleOverrides}>
			<header style={{ pointerEvents: (isEditor || (previewMode === 'session')) ? 'none' : 'auto' }}>
				<div className="session-titlebox">
					{hasLandingPage ? (
						<Link className="homepage-link" to={homepageLinkTo}><Icon name={ICONS.ARROW_LEFT} size={16} color="" /></Link>
					) : null}
					{homepageLinkImage && <img src={homepageLinkImage} alt="" />}
					<div className="session-title-text">
						{session.session_type !== 'on-demand' && <TypographyItem tagName={"p"}>{t("Scheduled for")} {startDate}</TypographyItem>}
						<TypographyItem tagName={"h5"}>{session.title[language] || session.title.base}</TypographyItem>
					</div>
				</div>
				<MarketingNavMenu isEditorDesktop={isDesktop} previewLanguage={previewLanguage} template={template} />
			</header>
		</div>
	);
};

export default SessionHeader;